import {ClickEvent} from "../../../../infrastructure/models/analytics/click-event";
import {APP} from "../../../../core/app/consts";
import {NEW_SEARCH_WIDGET} from "../../new-search-widget.consts";

export class NewSearchWidgetSeeAllClickEvent extends ClickEvent {
  source: APP.ANALYTICS.SOURCES;

  constructor(source: APP.ANALYTICS.SOURCES, id: number) {
    super('', 'see-more-click', 'search-tool');

    this.source = source;
    this.subSource = this.calcSubSourceById(id);
  }

  get properties() {
    const properties = super.properties;

    properties.source = APP.ANALYTICS.SOURCES.search;
    properties.subSource = this.subSource;

    return properties;
  }

  calcSubSourceById(id) {
    let subSource = 'none';
    if (id === NEW_SEARCH_WIDGET.LIST_ID.topAthletes || id === NEW_SEARCH_WIDGET.LIST_ID.searchAthletes) {
      subSource = 'athletes';
    } else if (id === NEW_SEARCH_WIDGET.LIST_ID.topCompetitions || id === NEW_SEARCH_WIDGET.LIST_ID.searchCompetitions) {
      subSource = 'leagues';
    } else if (id === NEW_SEARCH_WIDGET.LIST_ID.topCompetitors || id === NEW_SEARCH_WIDGET.LIST_ID.searchCompetitors) {
      subSource = 'teams';
    } else if (id === NEW_SEARCH_WIDGET.LIST_ID.recentSearches) {
      subSource = 'recent';
    }

    return subSource;
  }
}
